import { combineReducers } from 'redux';
import isSignedIn from "./is-signed-in";
import current from "./current";
import requests from "./requests";
import temp from "./temp";
import flags from "./flags";
import profiles from "./profiles";
import creditHistory from "./credit-history";
import creditSimulator from "./credit-simulator";
import tracking from "./tracking";
import smsVerification from "./sms-verification";
import yodlee from "./yodlee";
import flows from "./flows";
import visitorData from "./visitor-data";
import banking from "./banking";
import myBills from "./my-bills";
import financialData from "./financial-data";
import antiFraud from "./anti-fraud";
export default combineReducers({
  isSignedIn: isSignedIn,
  current: current,
  requests: requests,
  temp: temp,
  flags: flags,
  creditHistory: creditHistory,
  creditSimulator: creditSimulator,
  profiles: profiles,
  tracking: tracking,
  smsVerification: smsVerification,
  yodlee: yodlee,
  flows: flows,
  visitorData: visitorData,
  banking: banking,
  myBills: myBills,
  financialData: financialData,
  antiFraud: antiFraud
});